import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";


interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
  usedForFilter;
}

interface State {

}

export class GroupDropdownComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);
    let field = this.props.field;
    FormValidationUtils.runJavascript(field);
  }


  addGroup = (field: FormSectionElements) => {
    let htmlString = [];
    field.ListOfLOVValues.forEach(lov => {
      htmlString.push(
        <optgroup label={this.props.isEng ? lov.code : lov.FRA}>
          {this.subgroup(lov)}
        </optgroup>)
    })

    return htmlString;
  }

  subgroup = (lov) => {
    let htmlString = [];
    lov.subItems.forEach(sub => {
      htmlString.push(
        <option>{this.props.isEng ? sub.code : sub.FRA}</option>
      );
    });

    return htmlString;
  }

  onChange = (e) => {
    let field = this.props.field;
    if (field.Value && field.Value.indexOf(e.target.value) == -1)
      field.Value = `${field.Value};${e.target.value}`;
    else {
      field.Value = e.target.value;
    }

    FormValidationUtils.validateCheckGroup(field);
    FormValidationUtils.runJavascript(field);

    this.props.callbackElement(this.props.field.parent.parent.parent);

  }

  render() {
    let field = this.props.field;
    if(!field.Visible) return null;
    let controlArray = [];
    let labelControlArray = this.props.labelControlArray;

    controlArray.push(
      <div key={'div_' + field.Datatype +'_' + field.Id} id= {'div_' + field.Datatype +'_' + field.Id} className="ontario-form-group">
        <label className="ontario-label">
          {!this.props.usedForFilter ? <div key={'fdLbl_dropdown_label_' + field.Id} id={'fdLbl_dropdown_label_' + field.Id}>
            {labelControlArray}
          </div> : null}
        </label>
        <LiveValidationErrMsg
          field={this.props.field}
          isEng={this.props.isEng}
          key={"LiveValidationErrMsg_" + this.props.field.LoadBindName} />

        <select className={'ontario-input ontario-dropdown'}
          id={field.LoadBindName} 
          key={'group_dropdown_'  + field.Id}
          onChange={this.onChange}>
          {this.addGroup(field)}
        </select>
      </div>);

    let valString = [];
    if (field.Value) {
      let valList = field.Value.split(";");
      valList.forEach(p => {
        valString.push(<div className="ontario-label" style={{ display: 'flex', alignContent: 'center', alignItems: 'center', background: 'rgba(207, 237, 237, 0.5)' }}>
          <div><i className="pi pi-times" onClick={e => {
            const newArray = valList.filter(item => item !== p);
            field.Value = newArray.join(";");
            this.props.callbackElement(this.props.field.parent.parent.parent);
          }}></i>
          </div>
          <div style={{ marginLeft: '8px' }}>{p}
          </div>
        </div>
        );
      })
    }

    controlArray.push(valString);

    return controlArray;
  }
}